"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
/**
 * A typed version of lodash's _.groupBy.
 *
 * Returns a map of identifiers to elements from a given
 * list that return that identifier.
 *
 * @param iterable - the list to group by keys
 * @param getKey - the function to apply to an element of the list to get the key it should belong in
 * @returns a map of identifiers to values that mapped to that identifier
 */
function groupBy(iterable, getKey) {
    return iterable.reduce((groupedItems, item) => {
        var _a;
        const groupedKey = getKey(item);
        return groupedItems.set(groupedKey, [
            ...((_a = groupedItems.get(groupedKey)) !== null && _a !== void 0 ? _a : []),
            item,
        ]);
    }, new Map());
}
exports.groupBy = groupBy;
//# sourceMappingURL=groupBy.js.map